export const UNSUBSCRIBE_PARAMS = { WEEKS: "weeks", EMAIL: "email", ID: "id" };
